var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.componentType)?_c(_vm.componentType,{tag:"component",class:`layout-element--${_vm.element.type}`,attrs:{"element":_vm.element,"ratio":_vm.ratio,"font-size":_vm.fontSize,"tag":_vm.element.content.tag || null,"tag-class":_vm.tagClass}}):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }